import React, { useContext, useRef } from 'react';

import { Typography, IconButton, Stack, Paper, Container } from '@mui/material';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import { DataContext } from '../../../../context/DataContext';
import { PrintReport } from '../../../../components/PrintReport';

const PrintComprobante = ({ selected }) => {
	console.log('🚀  selected:', selected);
	const { title, slogan, icon } = useContext(DataContext);
	const { id, desde, hasta, motivo, fechaSolicitud, employee, diasEfectivos } = selected;

	const compRef = useRef();

	const pageStyle = `
    @media print {
      html, body {
        height: initial !important;
        overflow: initial !important;
        -webkit-print-color-adjust: exact;
      }
    }
    @media all {
      .pagebreak {
        display: none;
      }
    }
    @media print {
      .pagebreak {
        page-break-before: always;
      }
    }  
    @page { margin: 10mm; }
  `;

	return (
		<div>
			<Paper
				style={{
					padding: 20,
					textAlign: 'center'
				}}
			>
				<Stack display="flex" justifyContent="center">
					<img src={icon} style={{ width: 50, height: 50 }} />
					<Stack>
						<Typography variant="h5" textAlign={'center'}>
							{title}
						</Typography>
						<Typography textAlign={'center'}>{slogan}</Typography>
					</Stack>
					<ReactToPrint
						trigger={() => {
							return (
								<IconButton
									variant="outlined"
									style={{ position: 'absolute', right: 50, top: 75 }}
								>
									<PrintRoundedIcon
										style={{ fontSize: 35, color: '#2979ff', width: 35 }}
									/>
								</IconButton>
							);
						}}
						content={() => compRef.current}
						pageStyle={pageStyle}
					/>
				</Stack>

				<Stack direction="row" justifyContent="space-between" paddingLeft={20}>
					<Stack />
					<Stack>
						<Typography variant="h6" textAlign={'center'}>
							Comrpbante de Solicitud de Vacaciones
						</Typography>
					</Stack>
					<Stack>
						<Typography variant="h6" color="#f50057" textAlign="right">
							{`N° ${id}`}
						</Typography>
						<Typography variant="h6" color="#f50057" textAlign="right">
							{`Dias Efectivos: ${diasEfectivos}`}
						</Typography>
					</Stack>
				</Stack>

				<Stack spacing={3} marginTop={2}>
					<Typography textAlign={'left'}>
						MOTIVO:
						<Typography
							sx={{
								marginLeft: 1,
								textDecoration: 'underline',
								textUnderlineOffset: 8
							}}
							display="inline"
						>
							{` ${motivo}, DESDE: ${moment(desde).format('L')}, HASTA: ${moment(
								hasta
							).format('L')}`}
						</Typography>
					</Typography>

					<Typography textAlign={'left'}>
						FECHA SOLICITUD:
						<Typography
							sx={{
								marginLeft: 1,
								textDecoration: 'underline',
								textUnderlineOffset: 8,
								textTransform: 'uppercase'
							}}
							display="inline"
						>
							{`${moment().format('dddd,')} ${moment().format(
								'D'
							)} de ${moment().format('MMMM')} de ${moment().format('YYYY')}`}
						</Typography>
					</Typography>

					{/* <Typography textAlign={'right'}>
						{`Fecha: ${moment().format('dddd,')} ${moment().format(
							'D'
						)} de ${moment().format('MMMM')} de ${moment().format('YYYY')}`}
					</Typography> */}
				</Stack>

				<Stack direction="row" justifyContent="space-between" marginTop={10}>
					<Stack>
						<Typography textAlign={'center'}>
							--------------------------------------------
						</Typography>
						<Typography textAlign={'center'}>JEFE INMEDIATO</Typography>
						<Typography textAlign={'center'}>NELSON UBALDO RAMOS MAYORGA</Typography>
					</Stack>
					<Stack>
						<Typography textAlign={'center'}>
							--------------------------------------------
						</Typography>
						<Typography textAlign={'center'}>COLABORADOR</Typography>
						<Typography textAlign={'center'}>
							{employee.inssNumber} - {employee.fullName}
						</Typography>
					</Stack>
				</Stack>
			</Paper>

			<div
				style={{
					display: 'none'
				}}
			>
				<PrintReport ref={compRef} titulo={'Comprobante de solicitud de Vacaciones'}>
					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<hr />
						<Stack direction="row" justifyContent="space-between" paddingLeft={20}>
							<Stack />
							<Stack>
								<Typography variant="h6" textAlign={'center'}>
									Comrpbante de Solicitud de Vacaciones
								</Typography>
							</Stack>
							<Stack>
								<Typography variant="h6" color="#f50057" textAlign="right">
									{`N° ${id}`}
								</Typography>
								<Typography variant="h6" color="#f50057" textAlign="right">
									{`Dias Efectivos: ${diasEfectivos}`}
								</Typography>
							</Stack>
						</Stack>

						<Stack spacing={3} marginTop={2}>
							<Typography textAlign={'left'}>
								MOTIVO:
								<Typography
									sx={{
										marginLeft: 1,
										textDecoration: 'underline',
										textUnderlineOffset: 8
									}}
									display="inline"
								>
									{` ${motivo}, DESDE: ${moment(desde).format(
										'L'
									)}, HASTA: ${moment(hasta).format('L')}`}
								</Typography>
							</Typography>

							<Typography textAlign={'left'}>
								FECHA SOLICITUD:
								<Typography
									sx={{
										marginLeft: 1,
										textDecoration: 'underline',
										textUnderlineOffset: 8,
										textTransform: 'uppercase'
									}}
									display="inline"
								>
									{`${moment().format('dddd,')} ${moment().format(
										'D'
									)} de ${moment().format('MMMM')} de ${moment().format('YYYY')}`}
								</Typography>
							</Typography>
						</Stack>

						<Stack direction="row" justifyContent="space-between" marginTop={10}>
							<Stack>
								<Typography textAlign={'center'}>
									--------------------------------------------
								</Typography>
								<Typography textAlign={'center'}>JEFE INMEDIATO</Typography>
								<Typography textAlign={'center'}>
									NELSON UBALDO RAMOS MAYORGA
								</Typography>
							</Stack>
							<Stack>
								<Typography textAlign={'center'}>
									--------------------------------------------
								</Typography>
								<Typography textAlign={'center'}>COLABORADOR</Typography>
								<Typography textAlign={'center'}>
									{employee.inssNumber} - {employee.fullName}
								</Typography>
							</Stack>
						</Stack>
					</Container>
				</PrintReport>
			</div>
		</div>
	);
};

export default PrintComprobante;
